<template>  
    <div class="section">
        <h1 
            class="is-size-1-desktop is-hidden-touch has-text-centered has-text-white quote"
            style="margin-bottom:180px;margin-top:50px;"
            >
            80 gjester i fysisk konferanse, 10.000 i hybrid-/digitalkonferanse!
        </h1>

        <div class="bak is-hidden-desktop" style="margin-bottom:50px;">
            <h1 
                class="is-size-3-touch is-hidden-desktop has-text-centered has-text-white quote"
                >
                80 gjester i fysisk konferanse, 10.000<br/> i hybrid- eller digitalkonferanse!
            </h1>
        </div>
        <konferansehotell></konferansehotell>
        <Stromming></Stromming>

        <div class="has-text-centered" style="margin-top:100px;margin-bottom:80px;">   
            <a 
                href="mailto:booking@generalhotell.no?subject=Forespørsel%20fra%20nettsiden"
                class="button is-primary is-large has-text-white"
                alt="Send oss en forespørsel"
                >
                Send oss en forespørsel nå!
            </a>
        </div>    
    </div>
</template>

<script>
import Stromming from '@/components/Home/Stromming.vue'
import Konferansehotell from '@/components/Home/Konferansehotell.vue'

export default {
    name: 'Konferanse', 
    title: 'Konferanse på hotellet - rimelige konferansepakke',
    metaInfo: {
        meta: [
        { name: 'description', content: 'Kurs og konferanse på General Hotell. 2 konferansesaler og 2 flotte grupperom. Vi lager den ultimate konferansepakken uten å tømme lommeboken din. Vi tilbyr også digitale møter og gode streamingløsninger.'},
        { name: 'keywords', content: 'konferanse, kurs, seminar, møte, frokostmøte, kick-off, konferansehotell, møtepakker, møtepakke, hotell, konferanse senter, streaming, strømmetjenester, strømming, digitale møter' }
        ]
    },    
    components: {
        Stromming,
        Konferansehotell
    }    
}
</script>

<style scoped>
.bak {
    background-color: #000;
    opacity: 0.5;
    display: block;
    padding: 10px 10px 10px 10px;
}

</style>

    